
<template>
  <div class="brandsBox" v-if="brands.length > 0">
    <div
      class="col-12 col-lg-9 col-xl-10 brandsText"
    >
      <h4 class="bannerH4">Like the brand but can’t find the item? Cherrytree has access to over 550,000 products so not all products are shown on our site.</h4>
      <p>
        We can get you a discounted price on nearly all products from the brands shown here. Browse all our {{listingName}} brands and then simply <router-link :to="{name:'get-a-price'}" class="redLink">Request a Price</router-link> on any of their products.
      </p>
    <!--We have more to offer you than what is currently listed. You can access more {{listingName}} products from other brands. Browse their sites, then ask us for a quote.We have way more on offer than what is listed here.  Access more {{listingName}} products from other brands we supply. Browse on their site, come back to us for our special discounted price-->
    </div>
    <div class="col-12 col-lg-3 col-xl-2 align-self-center mx-auto text-center nopad">
      <div
        class="btn btn-light triangle buttonAlignTriangle"
        @click="() =>{isExpanded = !isExpanded}"
        :class="(isExpanded) ? 'activeTriangle' : ''"
      >{{ this.isExpanded ? 'HIDE BRANDS' : 'SEE BRANDS'}}</div>
    </div>

    <SlideUpDown
      :active="isExpanded"
      :initialHeight="0"
      class="col-12 myCollapse"
      :aria-expanded="isExpanded ? 'true' : 'false'"
    >
      <!-- <div > -->
        <!-- <h3>Like the brand but couldn't find the item?</h3>We can get you a discounted price in all the products from the brands below: -->
      <!-- </div> -->
      <div class="brandsList">
        <!-- TODO CMS wording,  -->
        <router-link
          v-for="brand in brands" :key="brand.id"
          :to="{name:'brand', params:{brand: brand.id, backName: listingName, backRoute: $route.fullPath}}"
          class="brand"
        >{{brand.title}}
        </router-link>
      </div>
    </SlideUpDown>
  </div>
</template>

<script>
//TODO Not loading all of them at once.
import SlideUpDown from "@/components/SlideUpDown";

export default {
  name: "ListingBrands",
  components: {
    SlideUpDown
  },
  props: ["hideControls", "brandsData", "listingName"], //will hold brands present in listing],
  data: () => {
    return {
      isExpanded: false
    };
  },
  mounted() {
    //event emitted by sidebar link to "SEE MORE BRANDS"
    this.$root.$on("expand-brands", () => {
      this.isExpanded = true;
    });
  },
  methods: {
  },
  computed: {
    brands() {
      return this.brandsData
    }
  }
};
</script>

<style lang="scss" scoped>
.brandsBox {
  background: $CTred;
  color: white;
  padding: 10px;
  box-sizing: content-box;
  padding-right: 5px;
}

.brandsText {
  font-size: 1rem;
  margin: 15px 0;
}

.brand {
  padding: 5px 15px;
  display: inline-block;
  color:white;
  text-decoration:none;
  &:hover{
    text-decoration:underline;
  }
}

.brandsList {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  //ensures that last row items don't get spread out too much
  &::after {
    content: "";
    flex: auto;
  }
}

.myCollapse {
  position: relative;
}

.nopad{
  padding: 0;
}
.bannerH4{
  font-size: 1.75em !important;
}

.redLink {
	color: white;
}
</style>
